import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, Image } from 'antd'
import SetUser from './set'
import ExerciseRecipe from './exerciseRecipe/index'
import EditExercisePrescription from './exercisePrescription/edit'
import EditMember from './edit'

const MemberDetail = (props) => {
  const [user, setUser] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isSetUserVisible, setIsSetUserVisible] = useState(false)
  const [isExerciseRecipeVisible, setIsExerciseRecipeVisible] = useState(false)
  const [isExercisePrescriptionVisible, setIsExercisePrescriptionVisible] = useState(false)
  const [isEditMemberVisible, setIsEditMemberVisible] = useState(false)

  const getUseDetail = () => {
    axios.post('/admin/user/detail/get', {
      user_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setUser(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getUseDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data])

  const handleCancel = () => {
    props.isCancel()
  }

  const editMember = (oid) => {
    setIsEditMemberVisible(true)
    setPropsData({ oid: oid})
  }

  const recommendedSportsRecipes = (oid) => {
    setIsExerciseRecipeVisible(true)
    setPropsData({ oid: oid})
  }

  const formulateExercisePrescription = (oid) => {
    setIsExercisePrescriptionVisible(true)
    setPropsData({ oid: oid})
  }

  const setMember = (oid, name) => {
    setIsSetUserVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  const closeAllModals = () => {
    setIsSetUserVisible(false)
    handleCancel()
  }

  return (
    <Modal 
      title="会员详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>

      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>头像</div>
          <div className='public-datail-photo'>
            <Image src={user.avatar_url || '/images/avatar.png'} width={80}/>
          </div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>姓名</div>
          <div className='public-datail-content'>{user.name || '未填写'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>手机号</div>
          <div className='public-datail-content'>{user.phone || '未填写'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>性别</div>
          <div className='public-datail-content'>{user.gender_value || '未填写'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>出生日期</div>
          <div className='public-datail-content'>{user.date_birth || '未填写'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>年龄</div>
          <div className='public-datail-content'>{user.age ? user.age + '岁' : '未填写'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>加入时间</div>
          <div className='public-datail-content'>{user.create_time || '未填写'}</div>
        </div>

        <div className='public-datail-buttons'>
          <div className='public-datail-button' onClick={() => {editMember(user.oid)}}>编辑会员资料</div>
          <div className='public-datail-button2' onClick={() => {recommendedSportsRecipes(user.oid)}}>推荐运动食谱</div>
          <div className='public-datail-button2' onClick={() => {formulateExercisePrescription(user.oid)}}>制定运动处方</div>
          <div className='public-datail-button3' onClick={() => {setMember(user.oid, user.name)}}>取消会员</div>
        </div>
      </div>

      {isSetUserVisible && <SetUser
        data={propsData}
        isOpen={isSetUserVisible} 
        isCancel={closeAllModals} 
        getUserData={props.getUserData} 
      />}
      {isEditMemberVisible && <EditMember
        data={propsData}
        isOpen={isEditMemberVisible} 
        isCancel={() => { setIsEditMemberVisible(false) }} 
        getUserData={props.getUserData} 
        getUseDetail={getUseDetail} 
      />}
      {isExerciseRecipeVisible && <ExerciseRecipe
        data={propsData}
        isOpen={isExerciseRecipeVisible} 
        isCancel={() => { setIsExerciseRecipeVisible(false) }} 
        getUserData={props.getUserData} 
      />}
      {isExercisePrescriptionVisible && <EditExercisePrescription
        data={propsData}
        isOpen={isExercisePrescriptionVisible} 
        isCancel={() => { setIsExercisePrescriptionVisible(false) }} 
      />}
    </Modal>
  )
}
export default MemberDetail
